export enum LoginFieldType {
	string = 1,
	url = 2,
	email = 3,
	password = 4,
	apiKey = 5,
	number = 6,
}
